(() => {
  const syncRatings = () => {
    document.querySelectorAll('[data-jh-product-section]').forEach((root) => {
      const badge = root.querySelector('[data-jh-rating-jump]');
      if (!badge) return;
      const reviews = Array.from(document.querySelectorAll('[data-jh-review-summary]')).find((section) => section.dataset.productId === root.dataset.productId);
      const localCount = Number(reviews?.dataset.reviewCount) || 0;
      const count = localCount || Number(badge.dataset.ratingCount) || 0;
      const rating = localCount ? Number(reviews.dataset.reviewAverage) : Number(badge.dataset.rating) || 0;
      const label = count > 0
        ? badge.dataset.ratingTemplate.replace('__rating__', String(rating)).replace('__count__', String(count))
        : badge.dataset.emptyLabel;
      badge.querySelector('[data-jh-rating-label]').textContent = label;
      badge.setAttribute('aria-label', label);
      badge.style.setProperty('--jh-rating-fill', `${Math.min(100, Math.max(0, rating * 20))}%`);
    });
  };
  const initialiseProduct = (root) => {
    if (root.dataset.jhProductReady === 'true') return;
    root.dataset.jhProductReady = 'true';

    const gallery = root.querySelector('[data-jh-product-gallery]');
    if (gallery) {
      const tabs = Array.from(gallery.querySelectorAll('[data-jh-media-tab]'));
      const panels = Array.from(gallery.querySelectorAll('[data-jh-media-panel]'));
      const counter = gallery.querySelector('[data-jh-media-index]');
      const hoverZoom = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
      const resetZoom = (panel) => {
        panel.classList.remove('is-zoomed');
        panel.style.removeProperty('--jh-zoom-x');
        panel.style.removeProperty('--jh-zoom-y');
      };

      panels.forEach((panel) => {
        if (!panel.querySelector(':scope > img')) return;
        const zoomAtPointer = (event) => {
          if (!hoverZoom.matches || event.pointerType === 'touch' || panel.hidden) {
            resetZoom(panel);
            return;
          }
          const bounds = panel.getBoundingClientRect();
          const x = Math.min(100, Math.max(0, (event.clientX - bounds.left) / bounds.width * 100));
          const y = Math.min(100, Math.max(0, (event.clientY - bounds.top) / bounds.height * 100));
          panel.style.setProperty('--jh-zoom-x', `${x}%`);
          panel.style.setProperty('--jh-zoom-y', `${y}%`);
          panel.classList.add('is-zoomed');
        };
        panel.addEventListener('pointerenter', zoomAtPointer);
        panel.addEventListener('pointermove', zoomAtPointer);
        panel.addEventListener('pointerleave', () => resetZoom(panel));
        panel.addEventListener('pointercancel', () => resetZoom(panel));
      });

      const selectMedia = (index, focus = false) => {
        const tab = tabs[index];
        if (!tab) return;
        panels.forEach((panel) => {
          resetZoom(panel);
          const active = panel.dataset.mediaId === tab.dataset.mediaId;
          panel.hidden = !active;
          if (!active) panel.querySelector('video')?.pause();
        });
        tabs.forEach((item, itemIndex) => {
          const active = itemIndex === index;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        if (counter) counter.textContent = String(index + 1);
        if (focus) tab.focus({ preventScroll: true });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectMedia(index));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'ArrowUp' && event.key !== 'ArrowDown') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
          selectMedia((index + direction + tabs.length) % tabs.length, true);
        });
      });
      const selectedIndex = Math.max(0, tabs.findIndex((tab) => tab.classList.contains('is-active')));
      selectMedia(selectedIndex);
    }

    const quantity = root.querySelector('[data-jh-quantity]');
    if (quantity) {
      const input = quantity.querySelector('input[name="quantity"]');
      quantity.querySelectorAll('[data-jh-quantity-change]').forEach((button) => {
        button.addEventListener('click', () => {
          const step = Number(input.step) || 1;
          const minimum = Number(input.min) || 1;
          const maximum = input.max ? Number(input.max) : Infinity;
          const current = Number(input.value) || minimum;
          const direction = Number(button.dataset.jhQuantityChange) || 0;
          input.value = String(Math.min(maximum, Math.max(minimum, current + direction * step)));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      input.addEventListener('change', () => {
        const minimum = Number(input.min) || 1;
        const maximum = input.max ? Number(input.max) : Infinity;
        input.value = String(Math.min(maximum, Math.max(minimum, Number(input.value) || minimum)));
      });
    }
  };

  const initialiseAll = (scope = document) => {
    if (scope.matches?.('[data-jh-product-section]')) initialiseProduct(scope);
    scope.querySelectorAll('[data-jh-product-section]').forEach(initialiseProduct);
    syncRatings();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(syncRatings));
})();
